<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
    <g clip-path="url(#clip0_288_3350)">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" fill="#F9F9F9" stroke="#E9E9E9"/>
      <path d="M20.0985 25.2915C21.335 25.2916 22.3744 26.3667 22.3744 27.6457C22.3744 28.9248 21.335 29.9999 20.0985 30C18.862 30 17.8216 28.9248 17.8216 27.6457C17.8216 26.3667 18.862 25.2915 20.0985 25.2915Z" fill="black"/>
      <path d="M20.1544 10C23.7795 10 25.9999 11.8895 26 14.5929C26 17.0058 24.4823 18.1687 23.1615 19.1281C22.178 19.8838 21.3071 20.5234 21.307 21.5989C21.307 22.064 21.5318 22.558 21.8128 22.8196L18.7498 23.7504C18.1597 23.0818 17.8217 22.2097 17.8216 21.1923C17.8216 19.1865 19.1714 18.2272 20.2955 17.3842C21.1666 16.7447 21.9255 16.1919 21.9255 15.3199C21.9255 14.4187 21.2786 13.6632 19.7329 13.6632C18.3278 13.6632 17.1471 14.3893 16.2759 15.4649L14 12.8196C15.4894 11.0174 17.7377 10.0001 20.1544 10Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_288_3350">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
